import React, { useState, useEffect, useCallback } from "react";
import { SimpleGrid, } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import Loading from "../../Component/Loading/loading";
import apiService from "../../Method/Report/Report_Service";
import { useDataContext } from "../../DataProvider";
import SalesHeader from "../../Component/Home/TOTAL_CARD";
import WAVE_CHART from "../../Component/Home/WAVE_CHART";
import BAR_CHART from "../../Component/Home/BAR_CHART";
import USER_CHART from "../../Component/Home/USER_CHART";

function Home() {

  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { trigger } = useDataContext();

  const fetchData = useCallback(async () => {

    setLoading(true);
    const { success, data, error } = await apiService.search("GET_HOME_DASHBOARD");

    if (success && data) {
      setLoading(false);
      setData(data);
      setError("")
    } else {
      setError(error);
      setLoading(false);
    }

  }, []);

  useEffect(() => {
    fetchData()
  }, [trigger, fetchData]);


  return (
    <div className="home">

      {error && <p className="error-message">{error}</p>}
      {isLoading && <Loading />}
      <div>
        {!isLoading && (
          <div style={{ width: "100%", marginTop: "10px" }}>
            <SimpleGrid

              gap={4}
              className="Total_Header_Without_Bg"
              style={{ background: "transparent" }}
              columns={{ base: 1, sm: 2, md: 4, lg: 5, "2xl": 7 }}
              columngap={50}
            >


              <SalesHeader
                title={t("SALES")}
                subtitle={data.ALL_TOTAL_SELL ? data.ALL_TOTAL_SELL.toLocaleString() : "0"}
                color="#091970"
              />

              <SalesHeader
                title={t("TOTAL_Discount")}
                subtitle={data.ALL_DISCOUNT_SELL ? data.ALL_DISCOUNT_SELL.toLocaleString() : "0"}
                color="#686868"
              />
              <SalesHeader
                title={t("SERVICE")}
                subtitle={data.ALL_SERVICE_SELL ? data.ALL_SERVICE_SELL.toLocaleString() : "0"}
                color="#6A58D0"
              />
              <SalesHeader
                title={t("ERADAT")}
                subtitle={data.ALL_TOT_ERADAT_AMOUNT ? data.ALL_TOT_ERADAT_AMOUNT.toLocaleString() : "0"}
                color="#4C81AD"
              />
              <SalesHeader
                title={t("EXPENSES")}
                subtitle={data.ALL_TOT_EXPENSES_AMOUNT ? data.ALL_TOT_EXPENSES_AMOUNT.toLocaleString() : "0"}
                color="#F0073B"
              />
              <SalesHeader
                title={t("ORDER_TOTAL")}
                subtitle={data.ALL_TOTAL_ORDERS ? data.ALL_TOTAL_ORDERS.toLocaleString() : "0"}
                color="#4169E1"
              />
              <SalesHeader
                title={t("NET_TOTAL")}
                subtitle={data.ALL_NET_NET_SALES ? data.ALL_NET_NET_SALES.toLocaleString() : "0"}
                color="#2E8B57"
              />

            </SimpleGrid>



            <SimpleGrid

              gap={4}
              className="Total_Header_Without_Bg"
              style={{ background: "transparent" }}
              columns={{ base: 1, md: 2, lg: 2, "2xl": 2 }}
              columngap={50}
            >

              <BAR_CHART data={data} />

              <USER_CHART data={data} />

            </SimpleGrid>

            <WAVE_CHART data={data} />

          </div>
        )}
      </div>
    </div >
  );
}
export default Home;
